/**
 * @功能名称: 获取wxUnionid
 * @params:  null
 * @文件名称: getWXUnionid
 * @Date: 2019/2/219 下午15:16.
 * @Author: liux
 * @Copyright（C）: 2014-2019 X-Financial Inc.   All rights reserved.
 * 注意：本内容仅限于小赢科技有限责任公司内部传阅，禁止外泄以及用于其他的商业目的。
 */

import browsersInfo from '../../component/common/ySniff'
var browsers = browsersInfo.browsers
import getQueryString from '../../asset/vendor/getQueryString'
import {post} from '../../component/common/ajax.jquery';
// 获取微信openid/unionid
function getWXUnionid(){
  if(!browsers.wechat){
    return Promise.reject({errcode:-1,msg:'非微信环境'});
  }
  var params = {
    data:{
      _srcid: getQueryString('source'),
      redirectUrl: location.href
    }
  }
  return post('/h5/wechat/check_account_session',params).then((json)=>{
    if (json.errcode === 0) {
      return json
    } else {
      var data = json.data;
      if(/^http(s)?:\/\//.test(data.oauthUrl)){
        location.replace(data.oauthUrl)
      }
    }
  })
}



export default getWXUnionid



// WEBPACK FOOTER //
// ./src/common/helper/getWXUnionid.js